// extracted by mini-css-extract-plugin
module.exports = {"container":"xj604-","shine-lines":"_2B-Hbr"};